import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './CalltrackingWarning.css';

export const CalltrackingWarning: React.FC<{ onClick: React.MouseEventHandler }> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <ArticleHeading4>Вы будете звонить по защищённому номеру</ArticleHeading4>
      <ArticleParagraph1>Разговоры записываются: так мы быстрее вычисляем и блокируем мошенников</ArticleParagraph1>
      <Button
        fullWidth
        beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
        size="M"
        onClick={onClick}
      >
        Позвонить
      </Button>
    </div>
  );
};
